import EditMyProfile from '@efdigital/ll-xceed-v2/components/coaching/coach/edit-my-profile';
import type { CoachingCoachSettingsIndexModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/settings/index';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface IndexSignature {
  Args: {
    model: CoachingCoachSettingsIndexModel;
    controller: unknown;
  };
}

export default class CoachingCoachSettingsIndex extends Component<IndexSignature> {
  @service declare router: RouterService;

  // Reload published/pending after the coach submits a change request.
  refresh = () => {
    this.router.refresh('coaching.coach.settings.index');
  };

  <template>
    {{pageTitle "Profile"}}
    <div class="container py-3 px-3">
      <div class="row justify-content-center">
        <div class="col-12 col-xl-11 col-xxl-10 ll-coach-settings">
          <EditMyProfile
            @published={{@model.published}}
            @pending={{@model.pending}}
            @onSaved={{this.refresh}}
          />
        </div>
      </div>
    </div>
  </template>
}
